import PropTypes from 'prop-types'
import { View } from './View'

/**
 * IBAの独自コンポーネントです
 */
export const Input = ({ ...props }) => {
    return <View {...props} />
}

Input.propTypes = {
    /**
     * value変更時のイベントハンドラー<br>
     * (value: string | number,event: React.SyntheticEvent) => void
     */
    onChange: PropTypes.func,
    /**
     * フォーカスを失った時のイベントハンドラー<br>
     * (event: React.SyntheticEvent) => void
     */
    onBlur: PropTypes.func,
    /**
     * クリック時のイベントハンドラー<br>
     * (event: React.SyntheticEvent) => void
     */
    onClick: PropTypes.func,
    /**
     * 要素の幅
     */
    width: PropTypes.number,
    /**
     * ラベル
     */
    label: PropTypes.string,
    /**
     * ラベルに必須マークを表示する
     */
    required: PropTypes.bool,
    /**
     * プレースホルダー
     */
    placeholder: PropTypes.string,
    /**
     * 検索ボタンの表示
     */
    search: PropTypes.bool,
    /**
     * disabled
     */
    disabled: PropTypes.bool,
    /**
     * value<br>
     *※コンポーネント外で管理する場合
     */
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * inputをエラー時のデザインにする<br>
     * ※エラーメッセージがある場合は指定不要
     */
    hasError: PropTypes.bool,
    /**
     * エラーメッセージ
     */
    errorMsg: PropTypes.string,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Input.defaultProps = {
    width: 312,
    required: false,
    search: false,
    disabled: false
}
